import type { SwapsTranslations } from "../interfaces/swaps";

export const swapsTranslations: SwapsTranslations = {
  swap_title: "Currency Exchange",
  page_subtitle: "Convert balance between your own wallets instantly — no external recipient.",

  origin_label: "Origin Currency",
  destination_label: "Destination Currency",
  select_origin: "Select origin currency",
  select_destination: "Select destination currency",

  amount_origin_label: "Origin Amount",
  amount_destination_label: "Destination Amount",

  quote_breakdown: "Quote Breakdown",
  conversion_rate: "Conversion Rate",
  you_send: "You Send",
  you_receive: "You Receive",
  fees: "Fee",
  recalculate_quote: "Recalculate quote",

  quote_valid_for: "This rate is valid for",
  quote_expiring_soon: "Quote will expire soon",
  quote_expired_message: "The quote has expired",

  conversion_fee: "Conversion fee",
  converted: "Converted amount",
  total_debit: "Total debited",

  confirm_swap: "Confirm Swap",
  make_another_swap: "Make Another Swap",

  success_title: "Swap Successful!",
  success_description: "Your currency exchange has been completed successfully",
  previous_balance: "Previous Balance",
  current_balance: "Current Balance",
  change: "Change",

  loading_quote: "Getting quote...",
  loading_wallets: "Loading wallets...",
  retry: "Retry",
  error_origin_required: "Select an origin currency",
  error_destination_required: "Select a destination currency",
  error_amount_required: "Enter a valid amount",
  error_insufficient_balance: "Not enough balance to cover the amount and the fee",
  error_no_quote: "No quote available",
  error_swap_failed: "Error performing swap",

  available_balance_label: "Available balance:",
  wallet_not_activated_hint: "(not activated)",
  wallet_will_be_activated: "A wallet in this currency will be activated when you confirm the swap",
  no_wallets_title: "No active wallets",
  no_wallets_message:
    "You have no active wallets. Activate one from the Wallets section to exchange currencies.",
  convert_title: "Convert",
  convert_subtitle: "Between your wallets",
  convert_from: "From",
  convert_to: "To",
  convert_wallet: "{{currency}} wallet",
  convert_available: "Available {{amount}}",
  convert_balance: "Balance {{amount}}",
  convert_flip: "Swap wallets",
  convert_frozen: "Frozen",
  convert_send_label: "You convert",
  convert_receive_label: "You receive",
  convert_rate: "Exchange rate",
  convert_valid_for: "Price valid for {{time}}",
  convert_row_fee: "Fee",
  convert_row_debit: "Leaves your wallet",
  convert_row_credit: "Reaches your wallet",
  convert_fee_free: "No fee",
  convert_insufficient: "Not enough balance: you have {{balance}} and this conversion needs {{debit}}.",
  convert_quote_error: "We couldn't price this conversion. Try again.",
  convert_pair_unavailable: "We can't price {{from}} to {{to}} right now. Try again in a few minutes.",
  convert_retry: "Try again",
  convert_send_tip_title: "Sending this money to someone else?",
  convert_send_tip_body: "Do it from Send: we convert inside the transfer and it costs you less.",
  convert_send_tip_action: "Go to Send",
  convert_review: "Review conversion",
  convert_cancel: "Cancel",
  convert_close: "Close",
  convert_review_title: "Review and convert",
  convert_review_leaves: "Leaves your {{currency}} wallet",
  convert_review_lands: "Reaches your {{currency}} wallet",
  convert_review_irreversible: "The conversion is instant and can't be undone.",
  convert_review_edit: "Edit",
  convert_confirm: "Convert {{amount}}",
  convert_review_changed: "The price changed while you were reviewing. Check the figures before converting.",
  convert_processing: "Converting your {{from}} to {{to}}…",
  convert_processing_hint: "It only takes a few seconds.",
  convert_transit_aria: "Converting {{debit}} from your {{from}} wallet to {{credit}} in your {{to}} wallet",
  convert_success_title: "You converted {{amount}}",
  convert_success_rate: "At {{rate}}",
  convert_success_landed: "Landed in your {{currency}} wallet",
  convert_balance_now: "Balance now",
  convert_again: "Convert again",
  convert_view_movements: "View movements",
  convert_done: "Done",
  convert_error_title: "The conversion didn't go through",
  convert_error_generic: "We couldn't make the conversion. Nothing left your wallets.",
  convert_error_consumed:
    "The conversion may have gone through even though we got no answer. Check the wallet's movements before trying again.",
  convert_error_back: "Back",
  convert_read_only:
    "You can see these wallets, but your user can't convert. Ask an administrator in your organization.",
};
